import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import { BeyondPaginationModel } from '@base/model/common/beyond-pagination.model';
import { Observable } from 'rxjs';
import { ObjectService } from '@views/secured/object/services/object.service';
import { ItemActionParamsModel } from '@views/secured/object/components/object/model/item-action-params.model';
import { ObjectDefinitionModel } from '@base/modules/rest/bbs-object/model/object-definition.model';
import { UntilDestroy } from '@ngneat/until-destroy';
import {
  MasterDataCardComponent
} from '@modules/master-data/components/master-data-cards/master-data-card/master-data-card.component';

@UntilDestroy()
@Component({
  selector: 'app-master-data-cards',
  templateUrl: './master-data-cards.component.html',
  styleUrls: ['./master-data-cards.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MasterDataCardsComponent {
  @Input() objectDefinition: ObjectDefinitionModel;
  @Input() pagination: BeyondPaginationModel;
  @Input() dataSource: any[];
  @Input() screenSizeSmall: boolean;
  @Input() isItemsView: boolean;
  @Input() isEditMode: boolean;
  @Output() paginationChangedEvent = new EventEmitter<BeyondPaginationModel>();
  @Output() itemActionEvent = new EventEmitter<ItemActionParamsModel>();
  @Output() itemsCardClickEvent = new EventEmitter<any>();
  @ViewChildren(MasterDataCardComponent) itemCards: QueryList<MasterDataCardComponent>;

  getCheckedItems(): any[] {
    return this.itemCards
      .filter(card => card.checkbox.checked)
      .map(card => card.item);
  }
}
